import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface RecallCampaignCardProps {
  campaignNumber: string | undefined;
  recallTitle?: string | undefined;
}

const isPlaceholderCampaign = (value: string): boolean =>
  !value || value === 'MANUAL' || value.startsWith('MANUAL-');

export const RecallCampaignCard: React.FC<RecallCampaignCardProps> = ({
  campaignNumber,
  recallTitle
}) => {
  if (!campaignNumber || isPlaceholderCampaign(campaignNumber)) return null;

  const displayNumber = campaignNumber.split('/')[0] || campaignNumber;

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 p-2 rounded bg-card',
        'border border-blue-500/30 dark:border-blue-400/30'
      )}
    >
      <div className='flex-1 min-w-0'>
        <div className='flex items-baseline gap-2'>
          <Badge
            variant='outline'
            className={cn(
              'text-xs shrink-0 bg-blue-500/10 text-blue-700 dark:text-blue-300',
              'border-blue-500/30 dark:border-blue-400/30'
            )}
          >
            {displayNumber}
          </Badge>
          {recallTitle && (
            <span className='text-sm text-foreground font-medium truncate'>{recallTitle}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecallCampaignCard;
